import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js'; // @ts-nocheck

/*
  @arrayOfProps: List of props from ownProps to merge with props:
  Example in mapStateToProps:
  import { updatePropsWithRouteProps } from "reactifi";
  props = updatePropsWithRouteProps(props, ownProps, ['jwt', 'adminifiDomain', 'languages']);
*/

var updatePropsWithRouteProps = function updatePropsWithRouteProps(props, ownProps, arrayOfProps) {
  for (var _i = 0, _Object$entries = Object.entries(ownProps.route); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (arrayOfProps.includes(key)) props[key] = value;
  }

  return props;
};

export { updatePropsWithRouteProps };